import request from "./index";
import qs from 'qs'

export const shareValidate = data =>
    request({
        method: 'get',
        url: '/share/validate',
        params: data
    });

export const shareLogin = data =>
    request({
        method: 'post',
        url: '/share/login',
        data,
    });

export const getDetail = data =>
    request({
        method: 'get',
        url: '/share/success',
        params: data
    });

export const downLoadValidate = data =>
    request({
        method: 'get',
        url: '/share/download',
        params: data
    });

export const findByRandomKey = data =>
    request({
        method: 'get',
        url: '/share/findByRandomKey',
        params: data
    });

export const getAdBanner = () =>
    request({
        method: 'get',
        url: '/share/banner',
    });


//*********************文件夹分享*****************************

//文件分享链接检测
export const panShareValidate = data =>
    request({
        method: 'get',
        url: '/panShare/validate',
        params: data
    });

//访问码登录
export const panShareLogin = data =>
    request({
        method: 'post',
        url: '/panShare/login',
        data,
    });

//获取文件夹信息
export const panShareSuccess = data =>
    request({
        method: 'post',
        url: '/panShare/success',
        data,
    });
    
//获取文件详情
export const panShareFileInfo = data =>
    request({
        method: 'post',
        url: '/panShare/fileInfo',
        data,
    });

//下载
export const panShareDownload = data =>
    request({
        method: 'post',
        url: '/panShare/download',
        data,
    });

//下载原件
export const panShareFileDownload = data =>
    request({
        method: 'post',
        url: '/panShare/fileDownload',
        data,
    });
     